(function () {
  'use strict';

  const MINIMUM_BUNDLE_ITEMS = 2;
  const BUNDLE_TARGET_ITEMS = 4;

  function getSelectedQuantities() {
    return Array.from(
      document.querySelectorAll(
        '.rbr-hrProducts__mam-qtyBox'
      )
    )
      .map((qtyBox) => {
        const quantityElement = qtyBox.querySelector(
          '.rbr-qtyBox__qty'
        );

        return quantityElement
          ? parseInt(quantityElement.textContent.trim(), 10) || 0
          : 0;
      })
      .filter((quantity) => quantity > 0);
  }

  function getSelectedItemCount() {
    return getSelectedQuantities().reduce(
      (total, quantity) => total + quantity,
      0
    );
  }

  function updateActiveState(qtyBox) {
    const quantityElement = qtyBox.querySelector('.rbr-qtyBox__qty');
    const quantityContainer = qtyBox.querySelector(
      '.rbr-qtyBox__qty-container'
    );

    if (!quantityElement || !quantityContainer) {
      return;
    }

    const quantity =
      parseInt(quantityElement.textContent.trim(), 10) || 0;

    let addedText = quantityContainer.querySelector(
      '.bundle-added-text'
    );

    if (!addedText) {
      addedText = document.createElement('span');
      addedText.className = 'bundle-added-text';
      addedText.textContent = 'added';

      quantityContainer.appendChild(addedText);
    }

    qtyBox.classList.toggle('active', quantity > 0);
    addedText.style.display = quantity > 0 ? 'inline' : 'none';
  }

  function replaceQuantityIcons(qtyBox) {
    if (
      !window.customBundleMinusIcon ||
      !window.customBundlePlusIcon
    ) {
      return;
    }

    const minusButton = qtyBox.querySelector(
      '.rbr-qtyBox__minus-container'
    );

    const plusButton = qtyBox.querySelector(
      '.rbr-qtyBox__plus-container'
    );

    if (
      minusButton &&
      !minusButton.querySelector('.svg-wrapper')
    ) {
      minusButton.innerHTML = `
        <span class="svg-wrapper">
          ${window.customBundleMinusIcon}
        </span>
      `;
    }

    if (
      plusButton &&
      !plusButton.querySelector('.svg-wrapper')
    ) {
      plusButton.innerHTML = `
        <span class="svg-wrapper">
          ${window.customBundlePlusIcon}
        </span>
      `;
    }
  }

  /*
   * YOUR BUNDLE
   */
  function addBundleTitle() {
    const totalBoxes = document.querySelectorAll(
      '.rbr-hrTotalBox__container'
    );

    if (!totalBoxes.length) {
      return;
    }

    totalBoxes.forEach((totalBox) => {
      let title = totalBox.querySelector(
        '.custom-bundle-title'
      );

      if (!title) {
        title = document.createElement('h2');
        title.className = 'custom-bundle-title';

        title.innerHTML = `
          <span>Your Bundle</span>
          <span class="svg-wrapper">
            ${window.customBundleArrow || ''}
          </span>
        `;

        totalBox.insertBefore(
          title,
          totalBox.firstElementChild
        );
      }

      // Add subtitle below the title
      let subtitle = totalBox.querySelector(
        '.custom-bundle-subtitle'
      );

      if (!subtitle) {
        subtitle = document.createElement('span');
        subtitle.className = 'custom-bundle-subtitle';
        subtitle.textContent =
          'Buy 2 tins, get 10% off.';

        title.insertAdjacentElement(
          'afterend',
          subtitle
        );
      }

      // Keep the offer visible in both Fast Bundle layouts.
      subtitle.hidden = false;
      subtitle.style.setProperty(
        'display',
        'block',
        'important'
      );
      subtitle.style.setProperty(
        'visibility',
        'visible',
        'important'
      );
      subtitle.style.setProperty(
        'opacity',
        '1',
        'important'
      );

      let summaryList = totalBox.querySelector(
        '.bundle-summary__list'
      );

      if (!summaryList) {
        summaryList = document.createElement('div');

        summaryList.className = 'bundle-summary__list';

        summaryList.setAttribute(
          'data-bundle-summary-list',
          ''
        );

        for (let i = 0; i < BUNDLE_TARGET_ITEMS; i++) {
          const item = document.createElement('div');

          item.className = 'bundle-summary__items';

          summaryList.appendChild(item);
        }

        // Put summary below the subtitle
        subtitle.insertAdjacentElement(
          'afterend',
          summaryList
        );
      }
    });
  }

  /*
   * GET FAST BUNDLE SELECTED PRODUCTS
   */
  function getSelectedProducts() {
    const container = document.querySelector(
      '.rbr-hrMamSelectedProducts__thumbnail__container'
    );

    if (!container) {
      return [];
    }

    return Array.from(
      container.querySelectorAll(
        ':scope > div > .rbr-thumbnail-container'
      )
    );
  }

  /*
   * Fast Bundle can render either one thumbnail per selected product or one
   * thumbnail per unit. Normalise both layouts into product/quantity groups.
   */
  function getSelectedProductGroups() {
    const selectedProducts = getSelectedProducts();

    if (!selectedProducts.length) {
      return [];
    }

    const selectedQuantities = getSelectedQuantities();

    const totalQuantity = selectedQuantities.reduce(
      (total, quantity) => total + quantity,
      0
    );

    // In the grouped layout there is one thumbnail per selected product.
    if (selectedProducts.length === selectedQuantities.length) {
      return selectedProducts.map((product, index) => ({
        product,
        quantity: selectedQuantities[index]
      }));
    }

    // Some Fast Bundle layouts already render one thumbnail per unit.
    if (selectedProducts.length === totalQuantity) {
      let productIndex = 0;

      return selectedQuantities.map((quantity) => {
        const group = {
          product: selectedProducts[productIndex],
          quantity
        };

        productIndex += quantity;

        return group;
      });
    }

    // Keep the summary usable if Fast Bundle changes its internal markup.
    return selectedProducts.map((product) => ({
      product,
      quantity: 1
    }));
  }

  /*
   * Use up to four summary cards. Quantities up to four are shown as
   * individual cards. Any remaining quantity is grouped into the last card
   * for that product, so only that card keeps a quantity badge.
   */
  function getSummaryProducts(maxSlots) {
    const groups = getSelectedProductGroups();

    if (!groups.length || maxSlots < 1) {
      return [];
    }

    const visibleGroups = groups.slice(0, maxSlots);
    const allocatedSlots = visibleGroups.map(() => 1);
    let remainingSlots = maxSlots - visibleGroups.length;

    while (remainingSlots > 0) {
      let groupIndex = -1;
      let largestUnallocatedQuantity = 0;

      visibleGroups.forEach((group, index) => {
        const unallocatedQuantity =
          group.quantity - allocatedSlots[index];

        if (unallocatedQuantity > largestUnallocatedQuantity) {
          largestUnallocatedQuantity = unallocatedQuantity;
          groupIndex = index;
        }
      });

      if (groupIndex === -1) {
        break;
      }

      allocatedSlots[groupIndex] += 1;
      remainingSlots -= 1;
    }

    return visibleGroups.flatMap((group, index) => {
      const individualCards = allocatedSlots[index] - 1;
      const groupedQuantity = group.quantity - individualCards;
      const cards = Array.from(
        { length: individualCards },
        () => ({
          product: group.product,
          quantity: 1
        })
      );

      cards.push({
        product: group.product,
        quantity: groupedQuantity
      });

      return cards;
    });
  }


  function updateAddButtonState() {
    const addButtons = document.querySelectorAll(
      '.bundle-add-button'
    );

    if (!addButtons.length) {
      return;
    }

    const isFull =
      getSelectedItemCount() >= BUNDLE_TARGET_ITEMS;

    addButtons.forEach((button) => {
      button.disabled = isFull;

      button.classList.toggle(
        'disabled',
        isFull
      );
    });
  }

  function updateBundleSubtitle() {
    const subtitles = document.querySelectorAll(
      '.custom-bundle-subtitle'
    );

    if (!subtitles.length) {
      return;
    }

    const selectedCount = getSelectedItemCount();

    subtitles.forEach((subtitle) => {
      if (selectedCount < 2) {
        subtitle.textContent =
          'Buy 2 tins, get 10% off.';
      } else if (selectedCount < 3) {
        subtitle.textContent =
          'Buy 3 tins, get 15% off.';
      } else {
        subtitle.textContent =
          'Buy 4 tins, get 20% off.';
      }

      subtitle.hidden = false;
      subtitle.style.setProperty(
        'display',
        'block',
        'important'
      );
      subtitle.style.setProperty(
        'visibility',
        'visible',
        'important'
      );
      subtitle.style.setProperty(
        'opacity',
        '1',
        'important'
      );
    });
  }

  function updateBundleCartButton() {
    const buttons = document.querySelectorAll(
      '.rbr-addBundleBtn-container'
    );

    if (!buttons.length) {
      return;
    }

    const selectedCount = getSelectedItemCount();

    const remaining = Math.max(
      MINIMUM_BUNDLE_ITEMS - selectedCount,
      0
    );

    const canAddToCart = remaining === 0;

    const newText =
      remaining > 0
        ? `Select ${remaining} more`
        : 'Add to cart';

    buttons.forEach((button) => {
      const buttonText = button.querySelector('span');

      const buttonElements = button.matches('button')
        ? [button]
        : Array.from(button.querySelectorAll('button'));

      button.classList.toggle(
        'disabled',
        !canAddToCart
      );

      if (canAddToCart) {
        button.removeAttribute('disabled');
        button.setAttribute('aria-disabled', 'false');
      } else {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      }

      buttonElements.forEach((buttonElement) => {
        buttonElement.disabled = !canAddToCart;
        buttonElement.classList.toggle(
          'disabled',
          !canAddToCart
        );
        buttonElement.setAttribute(
          'aria-disabled',
          String(!canAddToCart)
        );
      });

      if (
        buttonText &&
        buttonText.textContent.trim() !== newText
      ) {
        buttonText.textContent = newText;
      }
    });
  }


  function watchInitialBundleCartButton() {
    const updateButtonText = () => {
      const buttons = document.querySelectorAll(
        '.rbr-addBundleBtn-container'
      );

      if (!buttons.length) {
        return;
      }

      const selectedCount = getSelectedItemCount();

      // Only change the initial text
      // when nothing has been selected yet.
      buttons.forEach((button) => {
        const buttonText = button.querySelector('span');

        if (
          buttonText &&
          selectedCount === 0 &&
          buttonText.textContent.trim() === 'Add to cart'
        ) {
          buttonText.textContent =
            `Select ${MINIMUM_BUNDLE_ITEMS} more`;
        }
      });
    };

    // Try immediately
    updateButtonText();

    const observer = new MutationObserver(() => {
      updateButtonText();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /*
   * SYNC SUMMARY
   */
  function syncBundleSummary() {
    const summaryLists = document.querySelectorAll(
      '.bundle-summary__list'
    );

    if (!summaryLists.length) {
      return;
    }

    summaryLists.forEach((summaryList) => {
      const summaryItems = summaryList.querySelectorAll(
        '.bundle-summary__items'
      );

      const selectedProducts = getSummaryProducts(
        summaryItems.length
      );

      summaryItems.forEach((item) => {
        item.innerHTML = '';
        item.classList.remove('has-product');
      });

      selectedProducts.forEach((selection, index) => {
        const item = summaryItems[index];

        if (!item) {
          return;
        }

        const clone = selection.product.cloneNode(true);

        clone.removeAttribute('id');

        const quantityBadges = Array.from(
          clone.querySelectorAll('.rbr-quantity-container')
        );

        if (selection.quantity > 1 && quantityBadges[0]) {
          quantityBadges[0].textContent = `x${selection.quantity}`;
          quantityBadges[0].setAttribute(
            'quantity',
            selection.quantity
          );

          quantityBadges
            .slice(1)
            .forEach((quantityBadge) => quantityBadge.remove());
        } else {
          quantityBadges.forEach(
            (quantityBadge) => quantityBadge.remove()
          );
        }

        clone.classList.add(
          'bundle-summary__thumbnail'
        );

        item.appendChild(clone);

        item.classList.add('has-product');
      });
    });

    updateBundleSubtitle();
    updateBundleCartButton();
    updateAddButtonState();

  }
  

  /*
   * CHECK QUANTITY
   */
  function checkQuantityAndSync(qtyBox) {
    const quantityElement =
      qtyBox.querySelector(
        '.rbr-qtyBox__qty'
      );

    if (!quantityElement) {
      return;
    }

    const quantity =
      parseInt(
        quantityElement.textContent.trim(),
        10
      ) || 0;

    updateActiveState(qtyBox);

    /*
     * If quantity is zero,
     * sync immediately after Fast Bundle updates.
     */
    if (quantity === 0) {
      setTimeout(function () {
        syncBundleSummary();
      }, 100);

      return;
    }

    setTimeout(function () {
      syncBundleSummary();
    }, 100);
  }

  /*
   * ADD TO BAG
   */
  function addCustomBundleButton() {
    const qtyBoxes = document.querySelectorAll(
      '.rbr-hrProducts__mam-qtyBox'
    );

    qtyBoxes.forEach((qtyBox) => {
      updateActiveState(qtyBox);
      replaceQuantityIcons(qtyBox);

      /*
       * ADD TO BAG BUTTON
       */
      if (
        !qtyBox.querySelector(
          '.bundle-add-button'
        )
      ) {
        const button =
          document.createElement('button');

        button.type = 'button';
        button.className =
          'bundle-add-button';

        button.textContent =
          'Add to Bag';

        const quantityContainer =
          qtyBox.querySelector(
            '.rbr-qtyBox__container'
          );

        if (quantityContainer) {
          qtyBox.insertBefore(
            button,
            quantityContainer
          );
        } else {
          qtyBox.appendChild(button);
        }

        button.addEventListener(
          'click',
          function () {
            const plusButton =
              qtyBox.querySelector(
                '.rbr-qtyBox__plus-container'
              );

            if (!plusButton) {
              return;
            }

            plusButton.click();

            setTimeout(function () {
              checkQuantityAndSync(
                qtyBox
              );
            }, 200);
          }
        );
      }

      /*
       * MINUS BUTTON
       */
      const minusButton =
        qtyBox.querySelector(
          '.rbr-qtyBox__minus-container'
        );

      if (
        minusButton &&
        !minusButton.dataset.bundleListener
      ) {
        minusButton.dataset.bundleListener =
          'true';

        minusButton.addEventListener(
          'click',
          function () {
            /*
             * Wait for Fast Bundle quantity
             * to update.
             */
            setTimeout(function () {
              checkQuantityAndSync(
                qtyBox
              );
            }, 150);
          }
        );
      }

      /*
       * QUANTITY VALUE
       *
       * Observe changes to:
       *
       * .rbr-qtyBox__qty
       */
      const quantityElement =
        qtyBox.querySelector(
          '.rbr-qtyBox__qty'
        );

      if (
        quantityElement &&
        !quantityElement.dataset.bundleObserver
      ) {
        quantityElement.dataset.bundleObserver =
          'true';

        const quantityObserver =
          new MutationObserver(
            function () {
              checkQuantityAndSync(
                qtyBox
              );
            }
          );

        quantityObserver.observe(
          quantityElement,
          {
            childList: true,
            characterData: true,
            subtree: true
          }
        );
      }
    });
  }

  // Mobile toggle

  function initBundleMobileToggle() {
    const totalBoxes = document.querySelectorAll(
      '.rbr-hrTotalBox__container'
    );

    if (!totalBoxes.length) {
      return;
    }

    totalBoxes.forEach((totalBox) => {
      const title = totalBox.querySelector(
        '.custom-bundle-title'
      );

      const summaryList = totalBox.querySelector(
        '.bundle-summary__list'
      );

      if (!title || !summaryList) {
        return;
      }

      // Prevent duplicate listener
      if (title.dataset.mobileToggleInitialized === 'true') {
        return;
      }

      title.dataset.mobileToggleInitialized = 'true';

      title.addEventListener('click', function () {
        // Only work on mobile
        if (window.innerWidth > 989) {
          return;
        }

        title.classList.toggle('visible');

        summaryList.classList.toggle('is-open');
      });
    });
  }

  /*
   * INITIALIZE
   */
  function initBundle() {
    addBundleTitle();
    addCustomBundleButton();
    initBundleMobileToggle();
    

    document
      .querySelectorAll(
        '.rbr-hrProducts__mam-qtyBox'
      )
      .forEach((qtyBox) => {
        updateActiveState(qtyBox);
        replaceQuantityIcons(qtyBox);
      });
  }

  initBundle();
  watchInitialBundleCartButton();

  /*
   * Fast Bundle can re-render elements,
   * so keep this observer only for
   * re-attaching our buttons/listeners.
   */
  const observer =
    new MutationObserver(function () {
      initBundle();
    });

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();
